<template>
  <div class="expert-register-page" data-Name="专家注册">
    <GlobalHeader />

    <div class="main-content">
      <p class="page-title">专家注册信息填写</p>

      <a-form-model ref="ruleForm" :model="form" :rules="rules" class="register-form">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="专家姓名：" prop="Name" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.Name" placeholder="请输入姓名" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="身份证号：" prop="IdCard" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.IdCard" placeholder="请输入身份证号" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="工作单位：" prop="WorkUnit" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.WorkUnit" placeholder="请输入工作单位" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="邮箱：" prop="Email" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.Email" placeholder="请填写电子邮箱" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="登录手机号：" prop="Phone" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.Phone" placeholder="请填写登录手机号" />
            </a-form-model-item>

            <a-form-model-item label="登录密码：" prop="PassWord" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input-password size="large" v-model="form.PassWord" placeholder="请填写登录密码" />
            </a-form-model-item>

            <a-form-model-item prop="SmsCode" :wrapper-col="{ span: 16, offset: 8 }">
              <VerifyCodeInput v-model="form.SmsCode" :phone-number="form.Phone" :sms-code-type="1" send-type="register" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="开户银行：" prop="OpenBank" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.OpenBank" placeholder="请输入开户行" />
            </a-form-model-item>
            <a-form-model-item label="银行卡号：" prop="BankCard" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.BankCard" placeholder="请输入银行卡号" />
            </a-form-model-item>
          </a-col>

        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="学历：" prop="EducationLevel" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.EducationLevel" placeholder="毕业院校" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="EducationMajor" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.EducationMajor" placeholder="专业" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="职称：" :label-col="{ span: 8 }"
              :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.ProfessionalTitle" placeholder="职称" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item prop="ProfessionalTitleMajor" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.ProfessionalTitleMajor" placeholder="专业" />
            </a-form-model-item>
          </a-col> -->
        </a-row>
        <a-form-model-item label="专业特长：" prop="Category" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <ExpertCategorySelect ref="expertCategorySelect" v-model="form.Category" max="3" min="1" />
        </a-form-model-item>


        <a-form-model-item label="专家类别：" prop="ExpertType" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-radio-group v-model="form.ExpertType">
            <a-radio :value="1">入库专家</a-radio>
            <!-- <a-radio :value="3">其他入库专家</a-radio> -->
            <a-radio :value="2">非入库专家</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="专家证分类：" prop="CertificateCategory" :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }" v-if="form.ExpertType == 1">
          <a-checkbox-group v-model="form.CertificateCategory">
            <a-checkbox :value="1" >市财政</a-checkbox>
            <a-checkbox :value="2" >央财政</a-checkbox>
            <a-checkbox :value="3" >公共资源</a-checkbox>
            <a-checkbox :value="4" >其他</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item label="专家证书：" prop="CertificateFiles" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
          v-if="form.ExpertType==1">
          <div class="upload-container">
            <a-upload name="file" :multiple="true" :before-upload="beforeUpload" :file-list="form.CertificateFiles"
              @change="handleFileChange">
              <a-button size="large"> <a-icon type="upload" /> 上传附件 </a-button>
            </a-upload>
            <span class="upload-tip">请上传pdf或jpg格式的文件，单个文件不超过3M</span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="职称证书：" prop="ProfessionalFiles"
         :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
          v-if="form.ExpertType==1">
          <div class="upload-container">
            <a-upload name="file" :multiple="true" :before-upload="beforeUpload1" :file-list="form.ProfessionalFiles"
              @change="handleFileChange1">
              <a-button size="large"> <a-icon type="upload" /> 上传附件 </a-button>
            </a-upload>
            <span class="upload-tip">请上传pdf或jpg格式的文件，单个文件不超过3M</span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="回避信息：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <div v-for="(item, index) in form.AvoidInfo" :key="index" class="avoidance-item">
            <a-input size="large" v-model="form.AvoidInfo[index]" placeholder="请输入"
              style="width: 100%; margin-bottom: 10px;" />
          </div>
          <a-button type="dashed" icon="plus" @click="addAvoidanceItem" style="width: 60px"></a-button>
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 24 }" style="text-align: center; margin-top: 40px;">
          <a-button type="primary" @click="onSubmit" :loading="submitting" class="submit-button">确认注册</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue';
import VerifyCodeInput from '@/components/VerifyCodeInput.vue';
import ExpertCategorySelect from '@/components/ExpertCategorySelect.vue';
import { expertRegister } from '@/api/login';

export default {
  name: 'ExpertRegister',
  components: {
    GlobalHeader,
    VerifyCodeInput,
    ExpertCategorySelect
  },
  data() {
    return {
      type: this.$route.query.type,
      loading: false,
      submitting: false,
      form: {
        Name: '',
        IdCard: '',
        OpenBank: '',
        BankCard: '',
        EducationLevel: '',
        EducationMajor: '',
        ProfessionalTitle: '',
        // ProfessionalTitleMajor: '',
        PassWord: '',
        WorkUnit: '',
        Phone: '',
        Email: '',
        Category: [],
        SmsCode: '',
        CertificateFiles: [],
        ProfessionalFiles: [],
        ExpertType: undefined,
        CertificateCategory: [],
        AvoidInfo: ['', '', ''],
      },
    };
  },
  computed: {
    rules() {
      const validateCategory = (rule, value, callback) => {
        if (!value || value.length < 1) {
          callback(new Error('请选择专业特长'));
          return;
        }
        callback();
      };
      return {
        Name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        IdCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        PassWord: [{ required: true, message: '请填写登录密码', trigger: 'blur' }],
        WorkUnit: [{ required: true, message: '请输入工作单位', trigger: 'blur' }],
        Phone: [{ required: true, message: '请填写登录手机号', trigger: 'blur' }],
        SmsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        OpenBank: [{ required: true, message: '请输入开户银行', trigger: 'blur' }],
        BankCard: [{ required: true, message: '请输入开户行账号', trigger: 'blur' }],
        EducationLevel: [{ required: true, message: '请输入毕业院校', trigger: 'blur' }],
        EducationMajor: [{ required: true, message: '请输入毕业专业', trigger: 'blur' }],
        // ProfessionalTitle: [{ required: true, message: '请输入职称', trigger: 'blur' }],
        // ProfessionalTitleMajor: [{ required: true, message: '请输入职称专业', trigger: 'blur' }],
        Category: [{ required: true, validator: validateCategory, trigger: 'change' }],
        ExpertType: [{ required: true, message: '请选择专家类别', trigger: 'change' }],
        CertificateCategory: [{ required: this.form.ExpertType == 1, message: '请选择专家证分类', trigger: 'change', type: 'array', }],
        CertificateFiles: [{ required: this.form.ExpertType == 1, message: '请上传专家证', trigger: 'change', type: 'array' }],
        ProfessionalFiles: [{ required: this.form.ExpertType == 1, message: '请上传职称证书', trigger: 'change', type: 'array' }],
      };
    }
  },
  methods: {
    onSubmit() {
      console.log(this.form.Category,'this.form.Category')
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          try {
            const formData = new FormData();
            formData.append('Name', this.form.Name);
            formData.append('Phone', this.form.Phone);
            formData.append('PassWord', this.form.PassWord);
            formData.append('SmsCode', this.form.SmsCode);
            formData.append('IdCard', this.form.IdCard);
            formData.append('WorkUnit', this.form.WorkUnit);
            formData.append('OpenBank', this.form.OpenBank);
            formData.append('BankCard', this.form.BankCard);
            formData.append('EducationLevel', this.form.EducationLevel);
            formData.append('EducationMajor', this.form.EducationMajor);
            formData.append('ProfessionalTitle', this.form.ProfessionalTitle);
            // formData.append('ProfessionalTitleMajor', this.form.ProfessionalTitleMajor);

            // Handle Category array
            if (this.form.Category && this.form.Category.length) {
              this.form.Category.forEach((item, index) => {
                formData.append(`Category[${index}].Id`, item.id);
                formData.append(`Category[${index}].ParentId`, item.parentId);
              });
            }
            if (this.form.CertificateFiles && this.form.CertificateFiles.length > 0) {
              this.form.CertificateFiles.forEach((file, index) => {
                formData.append(`CertificateFiles`, file.originFileObj);
              });
            }
            if (this.form.ProfessionalFiles && this.form.ProfessionalFiles.length > 0) {
              this.form.ProfessionalFiles.forEach((file, index) => {
                formData.append(`ProfessionalFiles`, file.originFileObj);
              });
            }
            // Handle avoidanceInfo array
            const validAvoidanceInfo = this.form.AvoidInfo.filter(item => item.trim() !== '');
            if (validAvoidanceInfo.length) {
              validAvoidanceInfo.forEach((info, index) => {
                formData.append(`AvoidInfo`, info);
              });
            }

            if (this.form.Email) {
              formData.append('Email', this.form.Email);
            }
            if (this.form.ExpertType) {
              formData.append('ExpertType', this.form.ExpertType);
            }
            if (this.form.CertificateCategory && this.form.ExpertType == 1) {
              this.form.CertificateCategory.forEach((item, index) => {
                formData.append(`CertificateCategory`, item);
              });
            }
            this.submitting = true;
            expertRegister(formData).then(res => {
              if (res) {
                this.$message.success("注册成功");
                this.$router.push({
                  path: "/login",
                  query: {
                    type: this.type,
                  },
                });
              }
            }).finally(() => {
              this.submitting = false;
            })


          } catch (error) {
            console.error(error);
          }
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    // 拦截自动上传，改为手动提交
    beforeUpload(file) {
      this.form.CertificateFiles = [...this.form.CertificateFiles, file];
      return false;
    },
    handleFileChange(info) {
      // 由于使用了 beforeUpload 拦截，这里主要处理移除文件的逻辑
      let fileList = [...info.fileList];
      this.form.CertificateFiles = fileList;
    },
    // 拦截自动上传，改为手动提交
    beforeUpload1(file) {
      this.form.ProfessionalFiles = [...this.form.ProfessionalFiles, file];
      return false;
    },
    handleFileChange1(info) {
      // 由于使用了 beforeUpload 拦截，这里主要处理移除文件的逻辑
      let fileList = [...info.fileList];
      this.form.ProfessionalFiles = fileList;
    },
    addAvoidanceItem() {
      this.form.AvoidInfo.push('');
    },
  },
};
</script>

<style lang="less" scoped>
@import './Register.less';
</style>
